import { useContext } from 'react'
import { AuthContext } from '@/context/auth-context'
import { MessageDots } from '@/assets/icons'
import { BrandEnum } from '@/firebase/auth/auth-jwt-schema'
import { useHubspotConversations } from '@/context/useHubspotConversations'
import { useAppDispatch } from '@/store/store-hooks'
import { setMobileSidebarOpen } from '@/store/slices/ui-state.slice'

export default function SidebarItemSupport() {
  const { toggleWidget } = useHubspotConversations()
  const dispatch = useAppDispatch()

  // Auth Context
  const authContext = useContext(AuthContext)
  const { user, userAccountData } = authContext
  const userIsAnon = user?.isAnonymous
  const brand = userAccountData?.brand ?? BrandEnum.NONE

  // Support chat is only shown to anonymous users, and hidden for the Haiku brand.
  if (!userIsAnon || brand === BrandEnum.HAIKU) {
    return null
  }

  return (
    <div className="mt-auto px-4 py-1">
      <button
        type="button"
        onClick={() => {
          toggleWidget()
          dispatch(setMobileSidebarOpen(false))
        }}
        className="group flex w-[223px] items-center gap-2.5 rounded-md px-2 py-2 text-brand-neutral-600 transition-colors duration-200 hover:bg-brand-neutral-50 hover:text-brand-500"
      >
        <MessageDots className="h-5 w-5 text-brand-neutral-500 group-hover:text-brand-500" aria-hidden="true" />
        <span className="text-[14px] font-medium leading-[1.43] tracking-[-0.15px]">Chat with support</span>
      </button>
    </div>
  )
}
